export default __webpack_public_path__ + "static/media/tlogo.1bab706a.jpeg";